// extracted by mini-css-extract-plugin
module.exports = {"employement-statistics-container":"employmentStatistics_employement-statistics-container__37_Jw"};